import { Injectable } from "@angular/core";
import { Validators } from "@angular/forms";
import { BaseControl, Custom, PermisoRol, Textbox } from "@app/shared";

@Injectable()
export class ManagementMasterTableFormService {
  constructor() {}

  /**
   *Retorna el formulario de creacion o edicion de roles(grupos) en el sistema
   *
   * @param {*} templetesFomr
   * @param {*} options
   * @param {PermisoRol} [permission]
   * @return {*}  {BaseControl<any>[]}
   * @memberof ManagementMasterTableFormService
   */
   getFormRol(templetesFomr: any, objectModel: any): BaseControl<any>[] {
    const controls: BaseControl<any>[] = [
      new Custom({
        key: 'cboTypeMaster',
        label: 'Maestras',
        order: 1,
        template: templetesFomr.ngSelect,
        placeholder: 'Seleccione la maestra',
        value: objectModel ? objectModel['id_maestra'] ? objectModel['id_maestra'] : null : null,
        validations: {
          validators: [Validators.required]
        },
      }),
      new Textbox({
        key: "chWatch",
        type: "checkbox",
        value: objectModel ? (objectModel["ver"] ? objectModel["ver"] : false) : false,
        label: "Ver",
        size: "col-12 col-md-3",
      }),
      new Textbox({
        key: "chCreate",
        type: "checkbox",
        value: objectModel ? (objectModel["crear"] ? objectModel["crear"] : false) : false,
        label: "Crear",
        size: "col-12 col-md-3",
      }),
      new Textbox({
        key: "chDelete",
        type: "checkbox",
        value: objectModel ? (objectModel["eliminar"] ? objectModel["eliminar"] : false) : false,
        label: "Eliminar",
        size: "col-12 col-md-3",
      }),
      new Textbox({
        key: "chUpdate",
        type: "checkbox",
        value: objectModel ? (objectModel["modificar"] ? objectModel["modificar"] : false) : false,
        label: "Modificar",
        size: "col-12 col-md-3",
      }),
    ];

    return controls.sort((a, b) => a.order - b.order);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/groups-permissions/management-mastertable-permission/shared/management-mastertable.form.service.ts